export const isNDSPlan = function (planType) {
  return planType != null && planType.includes('NDS');
};
